import getInstanceAxios from "../request"
const baseDomain = process.env.NEXT_PUBLIC_NOTIFICATIONFIREBASE
const baseURL = `${baseDomain}/`

export default getInstanceAxios(baseURL)
